import { ForgotPasswordForm } from "@/components/form/ForgotPasswordForm";

const ForgotPasswordPage = () => {
  return <ForgotPasswordForm />;
};

export default ForgotPasswordPage;
